import React from 'react';
import { Skeleton, Stack } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import {
	CLAIM_NAME_MAX,
	CLIENT_NAME_MAX,
	FOLDER_NAME_MAX,
} from '@/components/dialogs/AddFolderSharepointDialog/validationSchema';
import { useTabContext } from '@/components/layouts/TabHeader/TabContext';
import { usePipelineContext } from '@/context/pipelineContext';
import { NameDisplay } from './NameDisplay';
import { NameInput } from './NameInput';
import { EditActions } from './EditActions';
import { useNameValidation } from './useNameValidation';
import { useNameSave } from './useNameSave';

export const NameChangeField = () => {
	const { clientRow, dealRow, loading, isClientView: isClient } = useObjectContext();

	const { closed: closedProspectStages } = usePipelineContext(
		process.env.REACT_APP_PIPELINE_PROSPECTS,
	);

	const isClaim = dealRow?.pipeline == process.env.REACT_APP_PIPELINE_CLAIMS;

	const getMaxLength = () => {
		if (isClient) return CLIENT_NAME_MAX;
		if (isClaim) return CLAIM_NAME_MAX;
		return FOLDER_NAME_MAX;
	};

	const maxLength = getMaxLength();

	const isProspect = isClient && clientRow?.isProspect;
	const isProspectClosed = isProspect && closedProspectStages?.includes(clientRow?.stage);

	const { isEditing, stopEditing, cancelEditing, fields, setFields, original } = useTabContext();

	const { error, setError, validateFolderName, validate } = useNameValidation();
	const { save, isSaving } = useNameSave({ setError });

	const handleSave = async () => {
		const valid = await validate(fields.title.trim());

		if (valid) {
			await save();
			stopEditing();
		}
	};

	return (
		<Stack direction='row' alignItems='center' spacing={1} width='100%'>
			{isSaving ? (
				<Skeleton animation='wave' width='100%' height='2em' />
			) : isEditing ? (
				<NameInput
					value={fields.title}
					onChange={(value) =>
						setFields('title', value.replace(/\s+/g, ' ').slice(0, maxLength))
					}
					onBlur={validateFolderName}
					error={error}
					maxLength={maxLength}
					disabled={loading}
				/>
			) : (
				<NameDisplay
					title={original.title}
					isProspect={isProspect}
					isProspectClosed={isProspectClosed}
				/>
			)}
			{isEditing && (
				<EditActions onCancel={cancelEditing} onSave={handleSave} disabled={isSaving} />
			)}
		</Stack>
	);
};
